import {
  CLEAR_PAGE_API_RESPONSE,
  PAGE_PUBLISH_SUCCESS,
  PAGE_PUBLISH_REJECTED,
  PAGE_UNPUBLISH_SUCCESS,
  PAGE_UNPUBLISH_REJECTED
} from './const';

/**
 * Returns action for page schedule publish success
 * @param {object} response - success response from schedule to publish.
 * @returns {object} Action Object
 */
export const publishPageSuccess = response => ({
  type: PAGE_PUBLISH_SUCCESS,
  response
});

/**
 * Returns action for page schedule publish
 * @param {object} pagePayload - page payload object for which publish was invoked.
 * @param {object} error - failure error object from schedule to publish.
 * @returns {object} Action Object
 */
export const publishPageFailure = (pagePayload, error) => ({
  type: PAGE_PUBLISH_REJECTED,
  pagePayload,
  error
});

/**
 * Returns action to clear page api response/error
 * @returns {object} Action Object
 */
export const clearPageApiResponse = () => ({
  type: CLEAR_PAGE_API_RESPONSE
});

/**
 * Returns action for page unpublish success
 * @param {object} response - success response from unpublish.
 * @returns {object} Action Object
 */
export const unpublishPageSuccess = response => ({
  type: PAGE_UNPUBLISH_SUCCESS,
  response
});

/**
 * Returns action for page unpublish
 * @param {object} pagePayload - pagePayload object for which unpublish was invoked.
 * @param {object} response - failure response from unpublish.
 * @returns {object} Action Object
 */
export const unpublishPageFailure = (pagePayload, response) => ({
  type: PAGE_UNPUBLISH_REJECTED,
  pagePayload,
  response
});
